'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Checkbox(props) {
  // withPropsOnChange(['isInvalid'], ({ isInvalid }) => ({
  //   style: isInvalid ? { borderColor: 'red', color: 'red' } : null,
  // }))
  var name = props.name,
      value = props.value,
      onChange = props.onChange,
      label = props.label,
      inputRef = props.inputRef,
      disabled = props.disabled;


  return _react2.default.createElement(
    'label',
    null,
    _react2.default.createElement('input', {
      ref: inputRef,
      type: 'checkbox',
      name: name,
      checked: !!value,
      onChange: onChange,
      disabled: disabled
    }),
    label
  );
}

var string = _propTypes2.default.string,
    bool = _propTypes2.default.bool,
    func = _propTypes2.default.func;

Checkbox.propTypes = {
  value: bool,
  onChange: func.isRequired,
  disabled: bool,

  name: string,
  label: string,

  inputRef: func
};

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Checkbox/Checkbox.js
// module id = 1744
// module chunks = 0